import React from "react";
import { FiPlus, FiTrash } from "react-icons/fi";

const PageContainer = ({ title, onAdd, onDelete, children }) => {
  return (
    <div className="flex flex-col p-4 md:p-10 w-full overflow-y-auto h-full">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
        <h2 className="mb-4 md:mb-0 ">{title}</h2>

        <div className="flex space-x-2">
          <button
            onClick={onAdd}
            className="flex items-center justify-center bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-800 transition duration-300 w-40"
            aria-label="Add new item"
          >
            <FiPlus className="mr-2" />
            <span className="flex-1 text-center">Add</span>
          </button>

          <button
            onClick={onDelete}
            className="flex items-center justify-center bg-red-500 text-white py-2 px-4 rounded hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-800 transition duration-300 w-40"
            aria-label="Delete selected items"
          >
            <FiTrash className="mr-2" />
            <span className="flex-1 text-center">Delete</span>
          </button>
        </div>
      </div>

      {/* Page Content */}
      {children}
    </div>
  );
};

export default PageContainer;